import { defineMessages } from 'react-intl';

export default defineMessages({
  userType: {
    id: 'adminConsole.userType',
    defaultMessage: 'Utente Azimut',
    description: 'User type',
  },
  loginNotAuthorized: {
    id: 'adminConsole.login.notAuthorized',
    defaultMessage:
      "Il tuo utente non è abilitato all'accesso alla console di amministrazione.",
    description: 'Admin console login: user not in the allowed group',
  },
  loginFailed: {
    id: 'adminConsole.login.failed',
    defaultMessage: "Non è stato possibile completare l'accesso alla console di amministrazione.",
    description: 'Admin console login: popup closed or login error',
  },
  loginRetry: {
    id: 'adminConsole.login.retry',
    defaultMessage: 'Riprova',
    description: 'Admin console login: retry button',
  },
});
